import type { ReactElement } from 'react';
import { cloneElement } from 'react';

import { useGetCardSetConfig } from '#src/set/index.ts';

type Props = {
  setSlug?: Nullable<string>;
  children: ReactElement<{ className?: string }>;
  disabled?: boolean;
};

export const SetColorTheme = ({ setSlug, children, disabled }: Props) => {
  const getCardSetConfig = useGetCardSetConfig();
  const { colorTheme } = getCardSetConfig(setSlug);

  if (!colorTheme || disabled) {
    return children;
  }

  return cloneElement(children, {
    className: [children.props.className, colorTheme].filter(Boolean).join(' '),
  });
};
